export default {
    showFilterPane(state){
        return state.showFilterPane;
    },
    hasActiveResearchSession(state) {
        return state.hasActiveResearchSession
    }

}